// Realm-role names mirroring Keycloak (lowercase). Per ADR-0012 spirit (no
// magic strings) every role comparison in the FE goes through this const.
// Mirrors api `cz.devcors.potatorocket.security.Roles`.
//
// `ALL_ROLES` and the `isRole` type-guard are intentionally NOT exported
// until a feature genuinely needs them — re-add on first real caller.
export const Roles = {
  ADMIN: 'admin',
  BACKOFFICE: 'backoffice',
  DISPATCHER: 'dispatcher',
  // CHR-03 §2 / ADR-0046 — fourth realm role: app-wide READ-ONLY (UI
  // „viewer"). Sees the operational overview but every edit affordance is
  // suppressed FE-side and rejected (403) server-side. Excluded from admin
  // user-management and never an SMS recipient (by role).
  VIEWER: 'viewer',
} as const;

export type Role = (typeof Roles)[keyof typeof Roles];
